import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { HttpClientCustom } from './http.client';

@Injectable()
export class Configuration {
  public properties: any;

  constructor() {
    this.properties = {
      BI_BASE_URL: '/bi',
      EPMS_BASE_URL: '/epms/',
      USER_APP_URL: '/home',
      BUILU_NUMBER: ' kea-8.0-11072023021910-d0c620607c305066f823a67677c97368892e649e-master'
    };
  }

  get(key: any) {
    return this.properties && this.properties[key] ? this.properties[key] : '';
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/configuration.ts